import { useNavigate } from 'react-router-dom';
import { mergePublicTheme } from '../publicTheme';
import WhatsappContactButton from './WhatsappContactButton';
import WebChatWidget from './web/WebChatWidget';

// Barra de navegación compartida por las vistas públicas (tienda, cita, ticket,
// news). Muestra solo las secciones activas en la configuración de la empresa y
// navega entre ellas en la misma pestaña (SPA) para dar la sensación de estar
// siempre dentro de la misma página. `current` marca la sección activa.
const NAV_ITEMS = [
  { key: 'tienda', flag: 'tienda_activa',  path: 'tienda', label: 'Productos' },
  { key: 'cita',   flag: 'cita_activa',    path: 'cita',   label: 'Servicios' },
  { key: 'ticket', flag: 'tickets_activa', path: 'ticket', label: 'PQR' },
  { key: 'news',   flag: 'news_activa',    path: 'news',   label: 'Noticias' },
];

function PublicNavbar({ slug, store, current, subtitle, maxWidth = '1100px' }) {
  const navigate = useNavigate();
  const c = mergePublicTheme(store?.theme).colors;

  // La sección actual siempre se muestra como pestaña activa aunque su flag no
  // venga en la respuesta; las demás solo si están activas en la configuración.
  const items = NAV_ITEMS.filter(i => i.key === current || store?.[i.flag]);

  const tabBase = {
    padding: '8px 16px', borderRadius: '8px', cursor: 'pointer',
    border: `1px solid ${c.border}`, fontSize: '0.9rem', fontWeight: 600,
    fontFamily: 'inherit', whiteSpace: 'nowrap', transition: 'background 0.15s',
  };
  const activeTab = { ...tabBase, background: c.primary, color: c.background, cursor: 'default' };
  const idleTab = { ...tabBase, background: 'none', color: c.text };

  // Botón flotante del Canal Web: solo si la empresa lo activó y tiene un canal web.
  const showWebChat = store?.canal_web_activa && store?.web_channel_id && store?.company_id;
  const webChatColors = {
    primary: c.primary, header: c.primary, headerText: '#ffffff',
    background: '#ffffff', botBubble: c.surface || '#f1f5f9', botText: c.text || '#0f172a',
  };

  return (
    <>
    <header
      style={{
        position: 'sticky', top: 0, zIndex: 30,
        backgroundColor: c.background,
        borderBottom: `1px solid ${c.border}`,
        marginBottom: '2rem',
      }}
    >
      <div
        style={{
          maxWidth, margin: '0 auto', padding: '0.9rem 1.5rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: '1rem', flexWrap: 'wrap',
        }}
      >
        {/* Marca */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.9rem' }}>
          {store?.logo && (
             <a
             href={store.logo}
             target="_blank"
             rel="noopener noreferrer"
             title="Ver imagen"
           >
            <img
              src={store.logo}
              alt={store.name}
              style={{ width: '100px', height: '100px', objectFit: 'contain', borderRadius: '10px' }}
            />
             </a>
          )}
          <div>
            <h1 style={{ color: c.primary, fontSize: '1.35rem', margin: 0 }}>{store?.name}</h1>
            {subtitle && (
              <p style={{ color: c.textMuted, margin: '3px 0 0', fontSize: '0.85rem' }}>{subtitle}</p>
            )}
          </div>
        </div>

        {/* Navegación entre secciones + contacto */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
          {items.map(i =>
            i.key === current ? (
              <span key={i.key} style={activeTab} aria-current="page">{i.label}</span>
            ) : (
              <button key={i.key} onClick={() => navigate(`/p/${slug}/${i.path}`)} style={idleTab}>
                {i.label}
              </button>
            )
          )}
          {store?.whatsapp && <WhatsappContactButton number={store.whatsapp} />}
        </nav>
      </div>
    </header>
    {showWebChat && (
      <WebChatWidget
        companyId={store.company_id}
        channelId={store.web_channel_id}
        colors={webChatColors}
        variant="floating"
      />
    )}
    </>
  );
}

export default PublicNavbar;
